import styled from 'styled-components';

export const PopupDots = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 26px;
  align-items: center;
  justify-content: center;  
  cursor: pointer;
`;

export const PopupDot = styled.div`
  height: 3px;
  width: 3px;
  border-radius: 50%;
  background: ${props => props.theme.colors.secondaryDark};
  margin: 1px 0;
`;



// WEBPACK FOOTER //
// ./src/components/popovers/dropdown-with-dots/styled-components.js